var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form',{attrs:{"label-width":"100px"}},[_c('el-row',[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"报警时间"}},[_vm._v(" "+_vm._s(_vm.data.Warmtime)+" ")])],1),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"报警内容"}},[_vm._v(" "+_vm._s(_vm.data.Warmmessage)+" ")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }